import React from 'react';
import glamorous from 'glamorous';
import Button from 'react-toolbox/lib/button';
import Input from 'react-toolbox/lib/input';
import ValidatedInput from '../../../../../../common/components/ValidatedInput';
import ThemedInput from '../../../../../../common/components/ThemedInput';

export const noteStyle = {
  display: 'block',
  paddingTop: '4px',
  paddingBottom: '1rem',
  fontStyle: 'italic',
  fontSize: '1.2rem',
  color: '#585858',
};

export const actionContainer = {
  display: 'flex',
  flexWrap: 'nowrap',
};

export const PasswordInstructions = glamorous.div({
  ...noteStyle,
  '& ul': {
    marginLeft: '24px',
    marginTop: '8px',
  },
});

export const GuestFieldsContainer = glamorous.div({
  flexGrow: 1,
  padding: '10px',
  display: 'flex',
  '@media screen and (max-width: 768px)': {
    flexDirection: 'column',
  },
  '@media screen and (min-width: 769px)': {
    flexDirection: 'row',
  },
});

export const GuestNameField = glamorous(ValidatedInput, {
  rootEl: 'input',
  forwardProps: [
    ...Object.keys(ValidatedInput.propTypes),
    ...Object.keys(ThemedInput.propTypes),
    ...Object.keys(Input.propTypes),
  ],
})({
  flexGrow: 1,
  '@media screen and (min-width: 769px)': {
    marginRight: '20px',
    width: '50%',
  },
});

export const Tooltip = glamorous.span(
  {
    position: 'absolute',
    right: '0px',
    bottom: '40px',
    zIndex: 200,
    display: 'block',
    width: '24rem',
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: '1.4rem',
    textAlign: 'center',
    textTransform: 'none',
    pointerEvents: 'none',
    transition: 'cubic-bezier(0.4, 0, 0.2, 1) 200ms transform',
    transform: 'scale(0) translateX(-50%)',
    transformOrigin: 'bottom right',
    '& span': {
      display: 'block',
      padding: '0.8rem',
      color: '#ffffff',
      background: 'rgba(97,97,97,.9)',
      borderRadius: '0.2rem',
      fontSize: '16px',
    },
  },
  ({ active }) => {
    if (active) {
      return {
        transform: 'scale(1) translateX(-50%),',
      };
    }
  }
);

export const FormSubHeader = ({ children }) => {
  return (
    <div style={{marginBottom: '10px', marginTop: '32px', fontSize: '15px', fontWeight: 'bold'}}>
      {children}
    </div>
  );
};

export const Total = glamorous.h4(
  {
    borderWidth: '1px',
    margin: '8px 0',
    '@media screen and (max-width: 425px)': {
      width: '100%',
    },
    '@media screen and (min-width: 426px)': {
      width: '240px',
    },
  },
  ({ color }) => {
    return {
      color: color || '#333333',
    };
  }
);

export const RegistrationSubmit = glamorous(Button, {
  rootEl: 'button',
  forwardProps: [
    ...Object.keys(Button.propTypes),
    'raised',
    'primary',
    'label',
    'type',
  ],
})(
  {
    marginTop: '20px',
    padding: '0px !important',
    '@media screen and (max-width: 425px)': {
      float: 'none',
      width: '100%',
    },
  },
  ({ label, backgroundColor }) => {
    if (label.toLowerCase().includes('pay')) {
      return {
        width: '240px',
        marginTop: '0px',
        borderRadius: '0px !important',
        backgroundColor: `${backgroundColor} !important`,
      };
    }
    return {
      backgroundColor: `${backgroundColor} !important`,
    };
  }
);



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/RegistrationForm/styles.js